import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  companyConfig: association(),

  displayName: () => faker.commerce.productName(),
  status: () => faker.helpers.arrayElement(['online', 'offline', 'not-paired']),
  isOnline: (i) => i % 3 === 0,
  active: (i) => i % 2 === 0,
});
